var MOBILE_SCREEN_WIDTH = 768;
var TABLET_SCREEN_WIDTH = 1440;

export { MOBILE_SCREEN_WIDTH, TABLET_SCREEN_WIDTH };
//# sourceMappingURL=screen.js.map
